export default __webpack_public_path__ + "b067d539ab025afd74a004e0c79ab634.svg";